<template>
  <div
    v-if="visibleView || isPublicRoute"
    id="app"
    class="d-flex flex-column min-vh-100 theme6"
    ref="baseBody">
    <!-- Layout with Sidebar and Header -->
    <div v-if="!isPublicRoute">
      <Sidebar />
      <div class="main-content">
        <Header />

        <router-view style="padding-top: 70px" id="content-view" />
      </div>
    </div>
    
    <!-- Blank Layout (no sidebar/header) -->
    <div v-else>
      <router-view id="content-view" />
    </div>
    
    <footer v-if="!isPublicRoute" class="bg-dark text-center text-lg-start">
      <div
        class="d-flex flex-wrap justify-content-center align-items-center p-3 text-light"
        style="background-color: rgba(0, 0, 0, 0.2); gap: 0.5rem 1.25rem;"
      >
        <span>Provided by Digitech - GEMS. ©️ 2022 PT. Golden Energy Mines, Tbk.</span>
        <template v-if="careCenterWaUrl">
          <span class="d-none d-sm-inline text-white-50">|</span>
          <a
            :href="careCenterWaUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="care-center-link text-light font-weight-bold"
            @click.stop.prevent="openHelpdeskWa"
          >
            <i class="fe fe-help-circle mr-1"></i>
            Helpdesk
          </a>
        </template>
      </div>
    </footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import Keycloak from "keycloak-js";
import { hasMitraRole } from "./constants/mitraRole";
import { toWhatsAppUrl } from "@/utils/whatsappPhone";
export default {
  data() {
    return {
      AccessToken: "",
      keycloak: null,
      visibleView: false,
      appName: "Ugems University",
      kcOptions: {
        realm: process.env.VUE_APP_KEYCLOAK_REALM || "ugems",
        "auth-server-url": process.env.VUE_APP_KEYCLOAK_URL,
        url: process.env.VUE_APP_KEYCLOAK_URL,
        "ssl-required": "external",
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "url-shortener",
        resource: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "url-shortener",
        "verify-token-audience": true,
        "use-resource-role-mappings": true,
        "confidential-port": 0,
        "policy-enforcer": {}
      }
    };
  },
  computed: {
    isPublicRoute() {
      return this.$route.meta.public === true;
    },
    careCenterWaUrl() {
      return toWhatsAppUrl(process.env.VUE_APP_CARE_CENTER_WA || "08134259484");
    }
  },
  components: {
    Sidebar,
    Header
  },
  mounted() {
    // Skip authentication for public routes
    if (this.isPublicRoute) {
      this.visibleView = true;
      return;
    }
    
    this.keycloak = new Keycloak(this.kcOptions);
    this.authenticate();
  },
  watch: {
    // Watch for route changes to handle navigation between public and protected routes
    '$route'(to, from) {
      if (to.meta.public && !this.visibleView) {
        this.visibleView = true;
      }
    }
  },
  methods: {
    openHelpdeskWa() {
      if (!this.careCenterWaUrl) return;
      window.open(this.careCenterWaUrl, "_blank", "noopener,noreferrer");
    },
    authenticate: function () {
      this.AccessToken = "Authenticating....";

      this.keycloak
        .init({
          onLoad: "login-required"})
        .then(async (auth) => {
          if (!auth) {
            console.log("NOT Authenticated");
            this.AccessToken = "";
          } else {
            console.log("Authenticated");
            this.AccessToken = this.keycloak.token;
          }

          // console.log(this.keycloak);

          // test fetch
          // try {
          //   const resp = await axios.get(
          //     `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${
          //       process.env.VUE_APP_KEYCLOAK_REALM || "ugems"
          //     }/broker/google/token`,
          //     {
          //       headers: {
          //         Authorization: `Bearer ${this.keycloak.token}`
          //       }
          //     }
          //   );
          //   console.log(resp);
          // } catch (err) {
          //   // console.log("Failed to get google token",err);
          // }

          localStorage.setItem("ugems-accessToken", this.keycloak.token);
          localStorage.setItem(
            "ugems-refreshToken",
            this.keycloak.refreshToken
          );
          localStorage.setItem(
            "ugems-tokenParsed",
            JSON.stringify(this.keycloak.tokenParsed)
          );
          this.getProfile()
          if (this.AccessToken) {
            this.visibleView = true;
            
          }
        })
        .catch((err) => {
          console.log("Authenticated Failed");
          console.log("err", err);
        });
    },
    getProfile() {
      this.$store
        .dispatch("users/getProfile")
        .then(() => {
          let datas = this.$store.getters["users/profileData"];
          this.$store.commit('users/commitProfile', datas)
          localStorage.removeItem("fullname");

          setTimeout(() => {
            // localStorage.setItem("roles", datas.roles);
            localStorage.setItem("fullname", datas.fullname);
            localStorage.setItem("nik", datas.nik);
            localStorage.setItem("roles", datas.roles || datas.roles_uenroll[0]);
           this.$root.$emit("roles", datas.roles || datas.roles_uenroll[0])
           this.$root.$emit("nik",datas.nik)
           
           // Set dynamic app name based on role
           this.setAppName(datas.roles_uenroll);
          }, 150);
        })
        .then(() => {
          this.fullname = localStorage.getItem("fullname");
          // this.companyName = localStorage.getItem("company_name");
        });
    },
    setAppName(roles) {
      if (hasMitraRole(roles)) {
        this.appName = "BIB Academy";
        document.title = "BIB Academy";
      } else {
        this.appName = "Ugems University";
        document.title = "Ugems University";
      }
      
      // Store app name in localStorage for access by other components
      localStorage.setItem("appName", this.appName);
      
      // Emit event for other components
      this.$root.$emit("appName", this.appName);
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";

@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
/* MY CUSTOM CSS */
@import url("./assets/css/mycustom.css");

.navbar-brand-img {
  max-width: 100% !important;
  max-height: 100% !important;
}

.swal2-toast-offset {
  margin-top: 46px;
}

.care-center-link {
  text-decoration: none;
  white-space: nowrap;
}

.care-center-link:hover {
  color: #fff;
  opacity: 0.85;
}
</style>
